import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState } from 'react';

import Modal from '../../Modal';
import Cta from '../../OC/oc-cta';
import Picture from '../../OC/oc-picture';
import { connectLocation } from '../../location/LocationConnectors';

const HotspotHeroContainer = styled.div`
  background-image: url(${props =>
    props.locale === 'en-CA' || props.locale === 'fr-CA'
      ? 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_60/v1611079451/insulation/residential/landing/hero-mobile-ca.jpg'
      : 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_auto/v1672860078/insulation/residential/landing/hero-w-sprayfoam-mobile.jpg'});
  background-size: 530px;
  background-position-x: center !important;
  background-position-y: 220px !important;
  margin-bottom: 35px;
  background-repeat: no-repeat;

  @media screen and (min-width: 768px) {
    background-image: url(${props =>
      props.locale === 'en-CA' || props.locale === 'fr-CA'
        ? 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_60/v1/pagebuilder/uploads/prod/78b0965d-0907-4437-b79b-4d92f0356528/hero-desktop-ca%20%281%29'
        : 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_auto/v1672860079/insulation/residential/landing/hero-w-sprayfoam-desktop.jpg'});
    background-size: 768px 514px !important;
    background-position: bottom center !important;
  }

  @media screen and (min-width: 1200px), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    background-image: url(${props =>
      props.locale === 'en-CA' || props.locale === 'fr-CA'
        ? 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_60/v1/pagebuilder/uploads/prod/78b0965d-0907-4437-b79b-4d92f0356528/hero-desktop-ca%20%281%29'
        : 'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_auto/v1672860079/insulation/residential/landing/hero-w-sprayfoam-desktop.jpg'});
    background-size: 1340px 896px !important;
  }
`;

const HeroGrid = styled.div`
  display: grid;
  @supports (display: grid) {
    grid-template-columns: repeat(1, auto);
    grid-template-rows: repeat(24, 30px) 40px;
  }

  @media (min-width: 768px) {
    @supports (display: grid) {
      grid-template-columns: 1fr repeat(12, 64px) 1fr;
      grid-template-rows: repeat(28, 20px);
    }
  }

  @media (min-width: 1200px), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    -ms-grid-columns: 1fr 100px 100px 100px 100px 100px 100px 100px 100px 100px 100px 100px 100px 1fr;
    -ms-grid-rows: 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px 35px
      35px 35px 35px 35px 35px 35px;

    @supports (display: grid) {
      grid-template-columns: 1fr repeat(12, 100px) 1fr;
      grid-template-rows: repeat(26, 35px);
    }

    .fill {
      display: none;
      background: white;

      @media (min-width: 768px) {
        display: block;
      }
    }
  }
`;

const Main = styled.div`
  background: white;
  z-index: 1;
  padding-top: 0;
  position: relative;
  grid-column: 1 / 1;
  grid-row: 1 / 6;
  padding: 0 15px 0 15px;
  background: transparent;
  text-align: right;

  @media screen and (min-width: 768px) {
    background: white;
    position: relative;
    grid-column: 5 / 12;
    grid-row: 1 / 12;
    padding: 0 30px 0 0;
  }

  @media screen and (min-width: 1200px) {
    position: relative;
    grid-column: ${props => (props.locale === 'fr-CA' ? '4 / 12' : '5 / 12')};
    grid-row: 1 / 10;
    padding-top: 15px;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    -ms-grid-column: ${props => (props.locale === 'fr-CA' ? 4 : 5)};
    -ms-grid-column-span: ${props => (props.locale === 'fr-CA' ? 8 : 7)};
    -ms-grid-row: 1;
    -ms-grid-row-span: 10;
  }
`;

const TextContent = styled.div`
  position: relative;
  grid-column: 1 / 1;
  grid-row: 5 / 7;
  padding-top: 0;
  background: transparent;
  text-align: right;
  z-index: 1;
  padding: 0 15px;

  @media screen and (min-width: 768px) {
    background: white;
    position: relative;
    grid-column: 8 / 12;
    grid-row: 8 / 12;
    padding-top: 0;
    display: block;
    text-align: left;
  }

  @media screen and (min-width: 1200px) {
    position: relative;
    grid-column: 8 / 11;
    grid-row: 7 / 11;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    -ms-grid-column: 8;
    -ms-grid-column-span: 3;
    -ms-grid-row: 7;
    -ms-grid-row-span: 2;
  }
`;

const FillTop = styled.div`
  position: relative;
  background: white;
  z-index: 1;
  display: none;

  @media (min-width: 768px) {
    display: block;
    grid-column: 1 / 6;
    grid-row: 1 / 1;
  }

  @media screen and (min-width: 1200px) {
    grid-column: 1 / 6;
    grid-row: 1 / 1;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    -ms-grid-column: 1;
    -ms-grid-column-span: 6;
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
  }
`;

const InteractiveContainer = styled.div`
  position: relative;
  grid-column: 1 / 1;
  grid-row: 8 / 23;
  padding: 0;
  margin-top: 15px;

  @media screen and (min-width: 768px) {
    position: relative;
    grid-column: 2 / 14;
    grid-row: 13 / 27;
    margin: 0;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    -ms-grid-column: 2;
    -ms-grid-column-span: 12;
    -ms-grid-row: 13;
    -ms-grid-row-span: 16;
    padding: 15px;
  }
`;

const MenuContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  width: 75%;

  @media (min-width: 768px) {
    right: 15px;
    transform: translateX(0);
    left: auto;
    width: auto;
  }

  h5 {
    margin-bottom: 10px;

    @media (min-width: 1200px) {
      margin-bottom: 30px;
    }
  }

  .fac-cta {
    width: 100%;
  }
`;

const MenuGroup = styled.div`
  background: white;
  margin-bottom: 10px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 50%);
  padding: 10px 20px;

  @media (min-width: 1200px) {
    padding: 15px 20px;
  }
`;

const GroupHeading = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 10px;

  @media (min-width: 1200px) {
    font-size: 21px;
    line-height: 21px;
    margin-bottom: 15px;
  }
`;

const MenuCTAStyle = css`
  display: flex;
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 0;
  border-bottom: 1px solid #e6e6e6;
  color: #333333;
  text-decoration: none;
  align-items: center;

  @media (min-width: 1200px) {
    line-height: 18px;
    font-size: 18px;
    padding: 10px 0;
  }

  u {
    text-decoration: none;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:hover,
  &:focus,
  &.selected,
  &.hover {
    color: #d40f7d;
    cursor: pointer;

    u {
      text-decoration: underline;
    }
  }

  &:focus {
    outline-offset: 2px;
    outline-color: #d40f7d;
    outline-style: solid;
    outline-width: 2px;
  }
`;

const HotSpotTrigger = styled.span`
  ${MenuCTAStyle}
`;
const MenuLink = styled.a`
  ${MenuCTAStyle}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:after {
    content: '\f054';
    color: black;
    font-family: 'fontawesome';
  }

  &:hover {
    &:after {
      color: #d40f7d;
      text-decoration: none;
    }
  }
`;

const HotSpot = styled.span`
  color: black;
  background: white;
  font-weight: 700;
  position: absolute;
  border-radius: 15px;
  border: 2px solid white;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.75);
  display: none;

  @media (min-width: 768px) {
    display: block;
    font-size: 12px;
    line-height: 12px;
    padding: 0 3px;
  }

  @media (min-width: 1200px) {
    font-size: 26px;
    line-height: 26px;
    padding: 0 6px;
  }

  &:hover,
  &.selected,
  &.hover {
    color: white;
    background: #d40f7d;
    box-shadow: 0px 0px 17px rgba(212, 15, 125, 1);
    cursor: pointer;
    text-decoration: none;

    @media (min-width: 1200px) {
      box-shadow: 0px 0px 35px rgba(212, 15, 125, 1);
    }
  }

  &.attics {
    @media (min-width: 768px) {
      top: 25px;
      left: 295px;
    }

    @media (min-width: 1200px) {
      top: 40px;
      left: 450px;
    }
  }

  &.floors {
    @media (min-width: 768px) {
      top: 105px;
      left: 490px;
    }

    @media (min-width: 1200px) {
      top: 180px;
      left: 800px;
    }
  }

  &.walls {
    @media (min-width: 768px) {
      top: 165px;
      left: 360px;
    }

    @media (min-width: 1200px) {
      top: 290px;
      left: 555px;
    }
  }

  &.basements {
    @media (min-width: 768px) {
      bottom: 60px;
      left: 220px;
    }

    @media (min-width: 1200px) {
      bottom: 100px;
      left: 315px;
    }
  }

  &.air-sealing {
    @media (min-width: 768px) {
      top: 80px;
      left: 280px;
    }

    @media (min-width: 1200px) {
      top: 150px;
      left: 420px;
    }
  }

  &.crawlspaces {
    @media (min-width: 768px) {
      bottom: 100px;
      left: 135px;
    }

    @media (min-width: 1200px) {
      bottom: 170px;
      left: 170px;
    }
  }

  &.sprayfoam {
    @media (min-width: 768px) {
      bottom: 100px;
      left: 135px;
    }

    @media (min-width: 1200px) {
      bottom: 340px;
      left: 625px;
    }
  }
`;

const InfoModalBody = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 65px;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  a {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (min-width: 768px) {
    a {
      margin-right: 16px;
      margin-bottom: 0;

      &:last-of-type {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  .columns {
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  .content-column {
    margin-bottom: 15px;

    @media (min-width: 768px) {
      margin-bottom: 0;
      flex-basis: 53%;
    }

    hr {
      margin: 15px 0;
    }

    &.image {
      text-align: center;

      @media (min-width: 768px) {
        flex-basis: 47%;

        .image-container {
          padding-left: 35px;
        }
      }

      img {
        max-width: 100%;
      }
    }
  }

  .pink {
    color: #d40f7d;
  }
`;

const ModalColumnContent = styled.div`
  margin-bottom: 15px;

  @media (min-width: 768px) {
    margin-bottom: 0;
    flex-basis: 53%;
  }

  .oc-cta-button {
    margin-top: 15px;
  }

  hr {
    margin: 15px 0;
  }
`;

const ModalColumnImage = styled.div`
  text-align: center;

  @media (min-width: 768px) {
    flex-basis: 47%;

    .image-container {
      padding-left: 35px;
    }
  }

  img {
    max-width: 100%;
  }
`;

const New = styled.span`
  text-transform: uppercase;
  color: white;
  background: #585858;
  padding: 3px 6px;
  border-radius: 20px;
  font-size: 11px;
  line-height: 11px;
  display: inline-block;
  font-weight: 700;
  margin-left: 8px;
`;

const NewIcon = connectLocation(({ t }) => <New>{t('residential.applications_new')}</New>);

const ResidentialInteractiveHero = connectLocation(({ t, locale }) => {
  const applications = t('residential.applications');
  const hotspots = t('residential.hotspots');
  const modals = t('residential.modals');
  const accessories = t('residential.accessories');
  const fac = t('residential.fac');

  const [hovered, setHovered] = useState('');
  const [selected, setSelected] = useState('');
  const [active, setActive] = useState(false);

  const onClose = () => {
    setActive(false);
    setSelected('');
  };

  return (
    <HotspotHeroContainer locale={locale.code}>
      <HeroGrid>
        <Main className="main rball-header" locale={locale.code}>
          <span className="prehead">{t('residential.hero_prehead')}</span>
          <h1 className="tier2">
            {t('residential.hero_heading_black')}
            <span className="pink">{t('residential.hero_heading_pink')}</span>
          </h1>
          <p />
        </Main>

        <TextContent>
          <p>{t('residential.hero_text')}</p>
        </TextContent>

        <InteractiveContainer className="test">
          <MenuContainer>
            <h5>
              <strong>{t('residential.applications_menu_heading')}</strong>
            </h5>

            <MenuGroup role="menu">
              {applications.map(menuItem => (
                <HotSpotTrigger
                  className={(hovered === menuItem.data_target || selected === menuItem.data_target) && 'hover'}
                  onMouseEnter={() => setHovered(menuItem.data_target)}
                  onMouseLeave={() => setHovered('')}
                  onClick={() => setSelected(menuItem.data_target)}
                  onKeyPress={e => {
                    if (e.key === 'Enter' || e.key === 'Space') {
                      setSelected(menuItem.data_target);
                    }
                  }}
                  tabIndex="0"
                  role="menuitem"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-track="select-by"
                  data-track-select-category="Commercial Applications"
                  data-track-select-option={menuItem.name}
                >
                  <u>{menuItem.name}</u>
                  {menuItem.new && <NewIcon />}
                </HotSpotTrigger>
              ))}

              {accessories != undefined && !accessories.includes('MISSING') && (
                <MenuLink
                  href={t('residential.accessories_url')}
                  tabindex="0"
                  role="menuitem"
                  aria-haspopup="false"
                  data-track="select-by"
                  data-track-select-category="Residential Insulation"
                  data-track-select-option="<%= et('residential.accessories') %> & Specialty"
                >
                  {t('residential.accessories')}
                </MenuLink>
              )}
            </MenuGroup>

            {fac != undefined && !fac.includes('MISSING') && (
              <Cta
                className="fac-cta"
                href={t('residential.fac_url')}
                data-track="find-a-professional"
                data-track-professional="Contractor"
              >
                {t('residential.fac')}
              </Cta>
            )}
          </MenuContainer>

          {hotspots.map(hotspot => (
            <HotSpot
              className={`${(hovered === hotspot.data_target || selected === hotspot.data_target) && 'hover'} ${
                hotspot.class_name
              }`}
              onMouseEnter={() => setHovered(hotspot.data_target)}
              onMouseLeave={() => setHovered('')}
              data-track="select-by"
              data-track-select-category="Commercial Applications"
              data-track-select-option={hotspot.select_object}
              tabindex="-1"
              onClick={() => setSelected(hotspot.data_target)}
              onKeyPress={e => {
                if (e.key === 'Enter' || e.key === 'Space') {
                  setSelected(hotspot.data_target);
                }
              }}
            >
              +
            </HotSpot>
          ))}

          {modals.map(modal => (
            <Modal
              name={modal.heading}
              size="md"
              open={modal.id === selected && (() => setActive(true))}
              onClose={onClose}
            >
              <InfoModalBody>
                <ModalColumnContent>
                  <h2 className="h5">{modal.heading}</h2>
                  <h3 className="h2" dangerouslySetInnerHTML={{ __html: modal.content_heading }} />

                  <p dangerouslySetInnerHTML={{ __html: modal.text }} />

                  <Cta
                    href={modal.cta_url}
                    data-track="learn-more"
                    data-track-element-location="hero CTA"
                    data-track-destination={modal.data_track_destination}
                    dangerouslySetInnerHTML={{ __html: t('residential.modal_cta_text') }}
                  />
                </ModalColumnContent>

                <ModalColumnImage>
                  <Picture source={modal.img} />
                </ModalColumnImage>
              </InfoModalBody>
            </Modal>
          ))}
        </InteractiveContainer>

        <FillTop />
      </HeroGrid>
    </HotspotHeroContainer>
  );
});

export default ResidentialInteractiveHero;
